export default {
    root: ({props}) => ({
        class: [
            //Font
            "text-xs font-bold",

            //Alignments
            "inline-flex items-center justify-center",

            //Spacing
            "px-2 py-1",

            //Shape
            {
                "rounded-md": !props.rounded,
                "rounded-full": props.rounded,
            },

            //Colors
            "text-white",
            {
                "bg-askr-green dark:bg-askr-green": props.severity == null || props.severity === "primary",
                "text-stone-700 dark:text-stone-300 bg-stone-100 dark:bg-stone-500/20": props.severity === "secondary",
                "bg-green-500 dark:bg-green-400": props.severity === "success",
                "bg-blue-500 dark:bg-blue-400": props.severity === "info",
                "bg-orange-500 dark:bg-orange-400": props.severity === "warn",
                "bg-red-500 dark:bg-red-400": props.severity === "danger",
                "text-stone-50 dark:text-stone-900 bg-stone-900 dark:bg-stone-50": props.severity === "contrast",
            },
        ],
    }),
    value: {
        class: "leading-normal",
    },
    icon: {
        class: "mr-1 text-sm",
    },
};
